import { CustomValidationRule } from '../../enums';
import { EditableSelectOptionsRequired } from './editable-select-options-required';
import { CopyFormRequired } from './copy-form-required';

export default {
	[CustomValidationRule.editableSelectOptionsRequired]: EditableSelectOptionsRequired,
	[CustomValidationRule.copyFormRequired]: CopyFormRequired
};
